import axios from "axios";

import { BASE_URL } from "../../src/utils/api_base_url_configration";


export const getUserListServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "user/list", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
export const deleteUserServ = async (id) => {
  try {
    const response = await axios.delete(BASE_URL + "user/delete/"+id);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
export const dashboardDetailsServ = async () => {
  try {
    const response = await axios.get(BASE_URL + "user/dashboard-details");
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const getUserCartServ = async (userId) => {
  try {
    const response = await axios.get(`${BASE_URL}user/cart/${userId}`);
    return response;
  } catch (error) {
    console.error("Error fetching user cart:", error);
    throw error;
  }
};

export const exportUserServ = async (formData) => {
  try {
    const response = await axios.post(
      BASE_URL + "user/export",
      formData,
      {
        responseType: "blob", // ensures Excel/CSV download works
      }
    );
    return response;
  } catch (error) {
    console.error("Error exporting users:", error);
    throw error;
  }
};
